import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

// Breakpoints: small (<=480), medium (481-768), full (>768)
const ResponsiveContext = createContext({
  isSmall: false,
  isMedium: false,
  isFull: true,
  width: typeof window !== 'undefined' ? window.innerWidth : 1024
});

export function ResponsiveProvider({ children }) {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    // Initial check in case SSR or delayed mount
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const value = useMemo(() => {
    const isSmall = width <= 480;
    const isMedium = width > 480 && width <= 768;
    const isFull = width > 768;
    return { isSmall, isMedium, isFull, width };
  }, [width]);

  return (
    <ResponsiveContext.Provider value={value}>{children}</ResponsiveContext.Provider>
  );
}

export function useResponsive() {
  return useContext(ResponsiveContext);
}


